import { ChangeDetectorRef, Component, EventEmitter, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AddressService } from '../../../../service/api/builk/address.service';
import { ISubscription } from 'rxjs-compat/Subscription';
import { PackageSaleService } from '../../../../service/api/builk/package-sale.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { CreateQuotationPackageModel } from '../../../../model/builk/package-sale/create-quotation-package.model';
import { BehaviorSubject } from 'rxjs';
import { CompanyService } from '../../../../service/api/builk/company.service';
import { CompanySelectorModel, CompanySelectorQueryModel } from '../../../../model/builk/company/company-selector.model';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { EmployeeListQueryModel, EmployeeModel } from '../../../../model/builk/company/employee.model';
import { TaxInvoiceCompanyTypeEnum } from '../../../../enum/builk/package-sale/tax-invoice-company-type.enum';

@Component({
  selector: 'app-add-quotation-modal',
  templateUrl: './add-quotation-modal.component.html',
  styleUrls: ['./add-quotation-modal.component.scss']
})
export class AddQuotationModalComponent {

  @Output() success = new EventEmitter();

  // ViewChild
  @ViewChild("template") template: TemplateRef<any>;

  //bs bootstrap
  modalRef: BsModalRef;

  // string

  // number
  empSurrKey: number;
  companySurrKey: number;
  limit = 50;
  companyTotalPages = 0;
  companyTotalItems = 0;
  companyCurrentPage = 1;
  empTotalPages = 0;
  empTotalItems = 0;
  empCurrentPage = 1;
  personType: number;
  withholdingTax: number = 3; // 3, 1
  whtValue = 0;
  state = 1;
  total = 0;
  grandTotal = 0;
  totalBeforeVat = 0;
  vatValue = 0;
  paymentMethod: number;
  tag: number;

  // boolean
  isCreating: boolean = false;
  loading = false;
  emploading = false;

  // form
  form: FormGroup;
  form2: FormGroup;

  // object
  companyQueryModel: CompanySelectorQueryModel = new CompanySelectorQueryModel();
  empQueryModel: EmployeeListQueryModel = new EmployeeListQueryModel();

  // array
  companyItemList: Array<CompanySelectorModel> = [];
  empItemList: Array<EmployeeModel> = [];
  paymentMethodOption: Array<{ label: string, value: number }> = [
    { label: 'Cash', value: 1 },
    { label: 'Credit', value: 2 }
  ]
  tagOption: Array<{ label: string, value: number }> = [
    { label: 'Workshop', value: 1 }
  ]

  // date
  paymentDate: Date;
  createDate: Date;

  // rxjs
  subscription: ISubscription;
  companyInput$ = new BehaviorSubject<string>('');
  empInput$ = new BehaviorSubject<string>('');

  constructor(
    private companyService: CompanyService,
    private packageService: PackageSaleService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private formBuilder: FormBuilder,
    private addressSelectorService: AddressService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private modalService: BsModalService,
  ) { }

  initData() {
    this.initForm();
    this.initForm2();

    this.empSurrKey = undefined;
    this.companySurrKey = undefined;
    this.limit = 50;
    this.companyTotalPages = 0;
    this.companyTotalItems = 0;
    this.companyCurrentPage = 1;
    this.empTotalPages = 0;
    this.empTotalItems = 0;
    this.empCurrentPage = 1;
    this.personType = undefined;
    this.withholdingTax = 3;
    this.whtValue = 0;
    this.state = 1;
    this.total = 0;
    this.grandTotal = 0;
    this.totalBeforeVat = 0;
    this.vatValue = 0;
    this.paymentMethod = undefined;
    this.tag = undefined;

    this.paymentDate = undefined;
    this.createDate =  undefined;

    this.companyQueryModel.limit = this.limit;
    this.companyQueryModel.page = 1;
    this.companyQueryModel.search = '';

    this.empQueryModel.limit = this.limit;
    this.empQueryModel.page = 1;
    this.empQueryModel.query = '';

    this.companyInput$.pipe(debounceTime(300)).subscribe(search => {
      this.searchCompany(search)
    });

    this.empInput$.pipe(debounceTime(300)).subscribe(search => {
      this.searchEmployee(search)
    });
  }

  openModal(): void {
    this.initData();
    this.modalRef = this.modalService.show(this.template,
      { class: "modal-md custom-quotation" , backdrop: 'static'}
    );
  }

  close(): void {
    this.modalRef.hide();
  }

  initForm() {
    this.form = this.formBuilder.group({
      paymentDate: [null, [Validators.required]],
      company: [null, [Validators.required]],
      packageName: [null, [Validators.required, Validators.maxLength(255)]],
      amount: [null, [Validators.required, Validators.min(0)]],
      projectTotal: [null, [Validators.required, Validators.min(1)]],
      paymentMethod: [null, [Validators.required]],
      employee: [null, [Validators.required]],
    });
  
    this.form.controls['employee'].disable();
  }

  initForm2() {
    this.form2 = this.formBuilder.group({
      personType: [null, [Validators.required]],
      withholdingTax: [3]
    });
  }

  validateForm(): boolean {
    let checkFormValidate = false;
    this.form.controls["paymentDate"].markAsTouched();
    this.form.controls["company"].markAsTouched();
    this.form.controls["packageName"].markAsTouched();
    this.form.controls["amount"].markAsTouched();
    this.form.controls["projectTotal"].markAsTouched();
    this.form.controls["paymentMethod"].markAsTouched();
    this.form.controls["employee"].markAsTouched();

    checkFormValidate = this.form.valid;
    return checkFormValidate;
  }

  validateForm2(): boolean {
    let checkFormValidate = false;
    this.form2.controls["personType"].markAsTouched();
    this.form2.controls["withholdingTax"].markAsTouched();

    checkFormValidate = this.form2.valid;
    return checkFormValidate;
  }

  createQuotationPackage() {
    if (!this.validateForm()) {
      return;
    }

    if (!this.validateForm2()) {
      return;
    }

    const model: CreateQuotationPackageModel = {
      paidDate: this.paymentDate,
      companySurrKey: this.companySurrKey,
      employeeSurrKey: this.empSurrKey,
      packageName: this.form.controls["packageName"].value,
      amount: Number(this.form.controls["amount"].value),
      projectTotal: Number(this.form.controls["projectTotal"].value),
      personType: Number(this.personType),
      withholdingTax: Number(this.withholdingTax),
      tag: this.tag ? Number(this.tag) : null,
    };

    this.isCreating = true;
    this.packageService.createQuotationPackage(model).subscribe(res => {
      if (res && res.status == 200) {
        this.success.emit();
        this.close();
      }
      this.isCreating = false;
    })
  }

  fetchCompanies(loadmore = false) {
    this.loading = true;
    this.companyService.getCompanySelecter(this.companyQueryModel).subscribe(res => {
      this.companyTotalItems = res.totalItem;

      if (loadmore == true) {
        this.companyItemList = this.companyItemList.concat(res.itemList);
        this.cdr.detectChanges();
      } else {
        this.companyItemList = res.itemList;
      }

      this.loading = false;
    });
  }

  onOpen() {
    if (this.companyItemList.length === 0) {
      this.fetchCompanies();
    }
  }

  onScrollToEnd() {
    if (this.companyItemList.length < this.companyTotalItems && !this.loading) {
      this.companyCurrentPage++;
      this.companyQueryModel.page = this.companyCurrentPage;
      this.fetchCompanies(true);
    }
  }

  onSearch(event: { term: string }) {
    this.companyInput$.next(event.term);
  }

  searchCompany(search: string) {
    this.companyCurrentPage = 1;
    this.companyItemList = [];
    this.companyQueryModel.search = search;
    this.fetchCompanies();
  }

  fetchEmployees(loadmore = false) {
    this.emploading = true;
    this.companyService.getEmployeeSearchList(this.empQueryModel).subscribe(res => {
      this.empTotalItems = res.totalCount;

      if (loadmore == true) {
        this.empItemList = this.empItemList.concat(res.list);
        this.cdr.detectChanges();
      } else {
        this.empItemList = res.list;
      }

      this.emploading = false;
    });
  }

  onScrollToEndEmp() {
    if (this.empItemList.length < this.empTotalItems && !this.emploading) {
      this.empCurrentPage++;
      this.empQueryModel.page = this.empCurrentPage;
      this.fetchEmployees(true);
    }
  }

  onSearchEmp(event: { term: string }) {
    this.empInput$.next(event.term);
  }

  searchEmployee(search: string) {
    if (this.companySurrKey) {
      this.empCurrentPage = 1;
      this.empItemList = [];
      this.empQueryModel.query = search;
      this.fetchEmployees();
    }
  }

  onCompanyChange() {
    if (this.companySurrKey) {
      this.empQueryModel.companySurrKey = this.companySurrKey;
      this.form.controls["employee"].enable();
      this.fetchEmployees();
    }
  }

  onPersonTypeChange() {
    if (this.personType == TaxInvoiceCompanyTypeEnum.JuristicPerson) {
      if (this.withholdingTax == undefined) {
        this.withholdingTax = 3;
      }
      this.onWithHoldingTax();
    } else {
      this.whtValue = 0;
      this.calculateGrandTotal();
    }
  }

  onWithHoldingTax() {
    this.whtValue = this.totalBeforeVat * (Number(this.withholdingTax) / 100);
    this.grandTotal = (this.totalBeforeVat + this.vatValue) - this.whtValue;
  }

  nextStep() {
    if (!this.validateForm()) {
      return;
    }

    this.state = 2;
    this.calculateGrandTotal();
  }

  calculateGrandTotal() {
    this.total = Number(this.form.controls['amount'].value);
    this.totalBeforeVat = this.total;
    this.vatValue = this.totalBeforeVat * 7 / 100;

    if (this.personType == TaxInvoiceCompanyTypeEnum.JuristicPerson) {
      let whtPercent = this.withholdingTax;
      let whtPercent2 = (whtPercent / 100);
      this.whtValue = this.totalBeforeVat * whtPercent2;
    }

    this.grandTotal = (this.totalBeforeVat + this.vatValue) - this.whtValue;
  }

  isInvalid(formControlName: string) {
    return this.form.controls[formControlName].touched && !this.form.controls[formControlName].valid;
  }
}
